import { Controller } from '@hotwired/stimulus';
import dayjs from 'dayjs';

export default class extends Controller {
  ON_RENDER_ACTIONS = ['setTimezone', 'setMeridian'];
  static targets = ['field'];

  connect() {
    if (!this.hasFieldTarget) return;
    const onRenderAction = this.fieldTarget.dataset.onRender;
    if (onRenderAction) this.#handleOnRenderAction(onRenderAction);
  }

  #handleOnRenderAction(renderAction) {
    const isValidAction = this.ON_RENDER_ACTIONS.includes(renderAction);
    if (isValidAction) {
      this[renderAction]();
    }
  }

  setTimezone() {
    this.fieldTarget.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  setMeridian() {
    const rawDateValue = this.fieldTarget.dataset.rawDateValue;
    if (!rawDateValue) return;
    const ampm = dayjs(rawDateValue).format('A');
    this.fieldTarget.value = ampm;
  }
}
